import forEach from 'lodash/forEach';
import { findLinkChanges, findNodeChanges } from './asset_next_hop_data_differ.service';
import { createNode } from '../force_directed_graph/force_directed_graph.service';

/**
 * AssetNextHopTreeView is the abstraction between our model and the D3 management object,
 * ForceDirectedGraph
 */
class AssetNextHopTreeView {
    _findNodeChanges: Function;
    _findLinkChanges: Function;
    _createNode: Function;
    _lastNodes;
    _lastLinks;
    _graph;
    _nextHopGraphData;
    _assetNextHopTreeViewFactoryHelper;

    constructor(
        forceDirectedGraph,
        nextHopGraphData,
        assetNextHopTreeViewFactoryHelper,
        findNodeChanges,
        findLinkChanges,
        createNode,
    ) {
        if (!assetNextHopTreeViewFactoryHelper) {
            throw 'assetNextHopTreeViewFactoryHelper cannot be null';
        }
        if (!forceDirectedGraph) {
            throw 'forceDirectedGraph cannot be null';
        }
        if (!nextHopGraphData) {
            throw 'nextHopGraphData cannot be null';
        }
        this._lastNodes = [];
        this._lastLinks = [];
        this._graph = forceDirectedGraph;
        this._nextHopGraphData = nextHopGraphData;
        this._assetNextHopTreeViewFactoryHelper = assetNextHopTreeViewFactoryHelper;
        this._findNodeChanges = findNodeChanges;
        this._findLinkChanges = findLinkChanges;
        this._createNode = createNode;
    }

    /**
     * Notify the view the graph data has been updated
     */
    graphDataUpdated(time?) {
        let self = this;
        let nextHopData = this._nextHopGraphData.getNextHopData();

        let nodeDiff = this._findNodeChanges(this._lastNodes, nextHopData.nodes);
        let linkDiff = this._findLinkChanges(this._lastLinks, nextHopData.links);

        this._lastNodes = nextHopData.nodes;
        this._lastLinks = nextHopData.links;

        self._graph.doScopedUpdate(() => {
            forEach(nodeDiff.added, (node) => {
                let nodeColor = self._assetNextHopTreeViewFactoryHelper.getColorForNode(node, time);
                self._graph.addNode(this._createNode(node.name, nodeColor));
            });
            forEach(nodeDiff.removed, (node) => {
                self._graph.removeNode(node.name);
            });
            forEach(nodeDiff.existsInBoth, (node) => {
                let nodeColor = self._assetNextHopTreeViewFactoryHelper.getColorForNode(node, time);
                self._graph.updateNode(this._createNode(node.name, nodeColor));
            });
            forEach(linkDiff.added, (link) => {
                // Hard code link length for now
                self._graph.addLink(link.source.name, link.target.name, '10');
            });
            forEach(linkDiff.removed, (link) => {
                self._graph.removeLink(link.source.name, link.target.name);
            });
        });
    }
}

/**
 * @param forceDirectedGraph ForceDirectedGraph instance
 * @param nextHopGraphData NextHopGraph data source
 * @param assetNextHopTreeViewFactoryHelper
 * @returns {AssetNextHopTreeView} A view instance
 */
export function createAssetNextHopTreeView(
    forceDirectedGraph,
    nextHopGraphData,
    assetNextHopTreeViewFactoryHelper,
) {
    return new AssetNextHopTreeView(
        forceDirectedGraph,
        nextHopGraphData,
        assetNextHopTreeViewFactoryHelper,
        findNodeChanges,
        findLinkChanges,
        createNode,
    );
}
